import Box from '@mui/material/Box';
import { getData } from 'clients/Clients';
import { getFuzzySearchClient } from 'clients/ProductClientV2';
import ProductCardNewList from 'components-v2/mocules/ProductCardNewList';
import ListProductWithTitle from 'components/mocules/ListProductWithTitle';
import SliderProductBlock from 'components/mocules/Skeleton/SliderProductBlock';
import { EnumProductsDisplayedMobile } from 'constants/Enums/app-settings';
import { EnumBlockCodeTracking } from 'constants/tracking';
import { useGetProductsDisplayedFromAppSettings } from 'hooks/useGetProductsDisplayedFromAppSettings';
import { useIsInViewportOnce } from 'hooks/useIsInViewportOnce';
import { useState } from 'react';
import { getSortedProducts, moveKcbPriorityFirst } from 'services/ProductService';
import useIsKcbVerified from 'hooks/useIsKcbVerified';
import ProductServiceV2 from 'services/ProductServiceV2';
import styles from './styles.module.css';
import SupplierClient from 'clients/SupplierClient';
import { sellerForStore } from 'utils/StoreUtils';

export default function ProductsSameIngredient({ product, blockCodeTracking = EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_INGREDIENT }) {
  const isKcbVerified = useIsKcbVerified();
  const [productsIngredient, setProductsIngredient] = useState([]);
  const [loading, setLoading] = useState(true);

  const MAXIMUM_PRODUCTS_INGREDIENT = useGetProductsDisplayedFromAppSettings(EnumProductsDisplayedMobile.PRD_DETAIL_INGREDIENT_PRODUCTS);

  const { elementRef } = useIsInViewportOnce({
    callback: async function fetchSameIngredient() {
      const ingredientCodes = product.ingredients?.map((ele) => ele.ingredientCode)?.slice(0, 2);
      if (ingredientCodes && ingredientCodes.length > 0) {
        setLoading(true);
        // GET 15 sản phảm theo ingredient thôi , vì có thể lên tận 1k hơn lận
        const promises = ingredientCodes.map((code) =>
          getFuzzySearchClient({
            body: { filter: { ingredient: code }, limit: 15 },
          }),
        );
        const listDataIngredientRes = await Promise.all(promises);

        const listProductRelative = listDataIngredientRes.map((dataIngredientRes) => getData(dataIngredientRes)).flat();

        const mapDataResult = await ProductServiceV2.mapDataProduct({
          result: {
            status: 'OK',
            data: listProductRelative,
          },
        });

        const filteredProducts = moveKcbPriorityFirst(
          getSortedProducts(
            getData(mapDataResult)
              ?.filter((prd) => prd.sku !== product.sku)
              .reduce((unique, o) => {
                if (!unique.some((prd) => prd.sku === o.sku)) {
                  unique.push(o);
                }
                return unique;
              }, [])
              ?.map((prd) => ({ ...prd, isSameIngredient: true }))
              .slice(0, MAXIMUM_PRODUCTS_INGREDIENT) || [],
          ),
          isKcbVerified,
        );

        const dataWithTracking = filteredProducts.map((item) => ({ ...item, blockCode: blockCodeTracking }));
        let sellerCodes = [];
        dataWithTracking?.forEach((item) => {
          if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
        });

        if (sellerCodes.length) {
          sellerCodes = [...new Set(sellerCodes)];

          const sellers = await SupplierClient.getSellersV2(sellerCodes).then(getData);
          const sellersMap = new Map(sellers.map((seller) => [seller.code, seller]));
          dataWithTracking?.forEach((item) => {
            item.sellerInfo = sellerForStore(sellersMap.get(item.seller.code), item.storeCode);
          });
        }

        setProductsIngredient(dataWithTracking);
      }
      setLoading(false);
    },
  });

  return (
    <section className="products-same-ingredients" ref={elementRef}>
      {loading ? (
        <SliderProductBlock />
      ) : (
        <Box className={styles.containerPage} style={{ marginTop: '20px' }}>
          <ListProductWithTitle
            iconWidth="40px"
            iconHeight="41px"
            name="Sản phẩm cùng hoạt chất"
            key="flagship-same-ingredients"
            viewMore
            redirect="/products"
          >
            {productsIngredient.map((product, index) => (
              <ProductCardNewList product={product} key={`item-product-${product.slug}`} index={index} />
            ))}
          </ListProductWithTitle>
        </Box>
      )}
    </section>
  );
}
